<template>
  <div class="card mb-10 shadow" v-if="!this.$root.loader">
    <ShowingHeader :showing="showing" :toggleExpand="expandShowingCard"></ShowingHeader>
    <transition name="slide-fade">
      <ShowingInterval :showing="showing" v-show="toggleExpand"></ShowingInterval>
    </transition>
  </div>
  <spinner v-else/>
</template>

<script>
import ShowingHeader from './ShowingHeader';
import ShowingInterval from './ShowingInterval';
import spinner from '../spinner';

export default {
  name: 'ShowingCard',
  components: {
    ShowingHeader,
    ShowingInterval,
    spinner
  },
  data() {
    return {
      toggleExpand: false,
    }
  },
  props: {
    showing: {
      type: Object,
    },
  },
  methods: {
    expandShowingCard() {
      this.toggleExpand = ! this.toggleExpand;
    }
  }
};
</script>

<style>
.card {
  background-color: white;
  padding: 15px;
  overflow: hidden;
}

</style>
